module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-app-e6427819.svg";